import { FhsAxios } from "../../services/axios";
import { hasItBeenLoaded } from "@/helpers/loading";

export default {
  state: {
    watchList: null
  },
  actions: {
    fetchWatchList({ commit, getters, state }, detailed = true) {
      // Прерываем выполнение, если список уже загружен
      commit("unsetWatchList");
      FhsAxios.post("user/watchlist", {
        uid: getters.userId,
        detailed
      }).then(response => {
        commit("setWatchList", response.data.result.watchlist);
      });
    },
    clearWatchList({ commit }) {
      commit("unsetWatchList");
    },
    subscribeToSecurity({ getters, dispatch }, securityTicker) {
      FhsAxios.post("user/watchlist/add", {
        uid: getters.userId,
        instrument: securityTicker
      }).then(() => {
        // Очищаем watchList, чтобы показать лоадер
        dispatch("clearWatchList");
        // Загружаем обновленный watchList
        dispatch("fetchWatchList");
      });
    },
    unsubscribeToSecurity({ getters, dispatch }, securityTicker) {
      FhsAxios.post("user/watchlist/delete", {
        uid: getters.userId,
        instrument: securityTicker
      }).then(() => {
        // Очищаем watchList, чтобы показать лоадер
        dispatch("clearWatchList");
        // Загружаем обновленный watchList
        dispatch("fetchWatchList");
      });
    }
  },
  mutations: {
    setWatchList(state, payload) {
      state.watchList = payload;
    },
    unsetWatchList(state) {
      state.watchList = null;
    }
  },
  getters: {
    watchList(state) {
      return state.watchList || [];
    },
    isWatchListLoading(state) {
      return state.watchList === null;
    },
    isWatchListEmpty(state) {
      return Array.isArray(state.watchList) && state.watchList.length === 0;
    }
  }
};
